import { cloneElement, } from "react";
import { useSplitTreatments } from "@splitsoftware/splitio-react";
import { logger } from "@moodys/mdc-frontend.services.logger";
import { LOG_TREATMENT_RESULT_DEFAULT } from "./split.constants";
const TREATMENT_CONTROL = "control";
export const SplitWrapper = ({ splitName, treatmentElementMap, loadingElement = null, logResult = LOG_TREATMENT_RESULT_DEFAULT, clientKey, }) => {
    const { isReady, treatments } = useSplitTreatments({ names: [splitName], splitKey: clientKey });
    const { treatment, config } = treatments[splitName];
    if (!isReady) {
        return loadingElement;
    }
    if (treatment === TREATMENT_CONTROL && logResult) {
        logger.debug({
            message: "Split result",
            splitName,
            treatment,
            config,
            componentName: "SplitWrapper",
        });
    }
    if (config) {
        try {
            const parsedConfig = JSON.parse(config);
            return cloneElement(treatmentElementMap[treatment], parsedConfig);
        }
        catch {
            logger.error({
                message: "Error parsing config JSON",
                treatment,
                componentName: "SplitWrapper",
            });
            return null;
        }
    }
    else {
        return treatmentElementMap[treatment] ?? null;
    }
};
//# sourceMappingURL=split-wrapper.js.map